import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ModuleHexagon from './ModuleHexagon';
import LessonsList from './LessonsList';
import LoaderInside from '../LoaderInside';
import lessonsData from '../../data/lessons.json';
import '../../scss/components/LessonsPage/LessonsPage.scss';

const LessonsPage = () => {
    const location = useLocation();
    const [modules, setModules] = useState([]);
    const [selectedModule, setSelectedModule] = useState(null);
    const [loading, setLoading] = useState(true);
    const [previousModuleId, setPreviousModuleId] = useState(null);
    const [animationPhase, setAnimationPhase] = useState('idle'); // idle, exit, enter

    useEffect(() => {
        // Имитация загрузки данных с сервера
        setTimeout(() => {
            setModules(lessonsData.modules);
            setLoading(false);

            // Проверяем, есть ли выбранный модуль в state навигации
            if (location.state && location.state.selectedModule) {
                const moduleFromNav = location.state.selectedModule;
                console.log('Получен модуль из навигации:', moduleFromNav);
                setSelectedModule(moduleFromNav);
                setAnimationPhase('enter');

                // Сбрасываем анимацию через некоторое время
                setTimeout(() => {
                    setAnimationPhase('idle');
                }, 1000);
            }
        }, 500);
    }, [location.state]);

    const handleModuleClick = (moduleId) => {
        // Если кликаем на тот же модуль или если уже идет анимация - ничего не делаем
        if (moduleId === selectedModule || animationPhase !== 'idle') {
            return;
        }

        if (selectedModule) {
            // Если есть выбранный модуль, запускаем анимацию выхода
            setPreviousModuleId(selectedModule);
            setAnimationPhase('exit');

            // После того как анимация выхода завершится, сбрасываем выбранный модуль
            setTimeout(() => {
                setSelectedModule(null);

                // Небольшая пауза перед началом анимации входа
                setTimeout(() => {
                    setSelectedModule(moduleId);
                    setAnimationPhase('enter');

                    // После завершения анимации входа возвращаемся в исходное состояние
                    setTimeout(() => {
                        setAnimationPhase('idle');
                    }, 1000); // Время для завершения анимации входа (с учетом задержек)
                }, 100);
            }, 800); // Время для завершения анимации выхода
        } else {
            // Если нет выбранного модуля, просто устанавливаем новый с анимацией входа
            setSelectedModule(moduleId);
            setAnimationPhase('enter');

            // После завершения анимации входа возвращаемся в исходное состояние
            setTimeout(() => {
                setAnimationPhase('idle');
            }, 1000); // Время для завершения анимации входа
        }
    };

    // Найдем выбранный модуль по ID
    const activeModule = modules.find(module => String(module.id) === String(selectedModule));
    // Найдем предыдущий модуль для анимации
    const prevModule = modules.find(module => String(module.id) === String(previousModuleId));

    if (loading) {
        return (
            <div className="lessons-loading">
                <LoaderInside />
            </div>
        );
    }

    // Если нет активного модуля, но есть выбранный ID
    if (selectedModule && !activeModule && modules.length > 0) {
        console.log('Модуль не найден, но ID есть. Используем первый модуль');
        return (
            <div className="lessons-page-container">
                <div className="lessons-header">
                    <h1>ЗАДАНИЯ</h1>
                </div>

                <div className="modules-container">
                    {/* Угловые элементы */}
                    <div className="corner corner-tr"></div>
                    <div className="corner corner-bl"></div>
                    <div className="corner corner-br"></div>

                    {modules.map((module, idx) => (
                        <ModuleHexagon
                            key={module.id}
                            module={module}
                            isActive={idx === 0}
                            onClick={() => handleModuleClick(module.id)}
                            index={idx}
                        />
                    ))}
                </div>

                <LessonsList
                    lessons={modules[0].lessons}
                    moduleTitle={modules[0].title}
                    moduleId={modules[0].id}
                    animateIn={true}
                />
            </div>
        );
    }

    // Получаем текущий moduleId для передачи компоненту LessonsList
    const currentModuleId = animationPhase === 'exit' ? previousModuleId : selectedModule;

    return (
        <div className="lessons-page-container">
            <div className="lessons-header">
                <h1>ЗАДАНИЯ</h1>
            </div>

            <div className="modules-container">
                {/* Угловые элементы */}
                <div className="corner corner-tr"></div>
                <div className="corner corner-bl"></div>
                <div className="corner corner-br"></div>

                {modules.map((module, idx) => (
                    <ModuleHexagon
                        key={module.id}
                        module={module}
                        isActive={String(selectedModule) === String(module.id)}
                        onClick={() => handleModuleClick(module.id)}
                        index={idx}
                    />
                ))}
            </div>

            {/* Показываем уроки только если есть выбранный модуль или если идет анимация выхода */}
            {(selectedModule || animationPhase === 'exit') && (
                <LessonsList
                    lessons={(animationPhase === 'exit' ? prevModule : activeModule).lessons}
                    moduleTitle={(animationPhase === 'exit' ? prevModule : activeModule).title}
                    moduleId={currentModuleId}
                    animateIn={animationPhase !== 'exit'}
                />
            )}
        </div>
    );
};

export default LessonsPage; 